import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-file-fields-save-as-template-dialog',
    templateUrl: './file-fields-save-as-template-dialog.component.html',
    styleUrls: ['./file-fields-save-as-template-dialog.component.scss'],
    imports: [DialogModule, ReactiveFormsModule, TranslateModule]
})
export class FileFieldsSaveAsTemplateDialogComponent implements OnInit {
  @Output()
  public saveAsTemplate: EventEmitter<string> = new EventEmitter<string>()

  @ViewChild("saveAsTemplateDialog")
  public dialog: DialogComponent;

  public form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      templateName: ['', Validators.required]
    });
  }

  public show() {
    this.form.reset({
      templateName: ''
    });
    this.dialog.show();
  }

  public onCancel() {
    this.dialog.hide();
  }

  public onOk() {
    this.saveAsTemplate.emit(this.form.getRawValue()?.templateName);
    this.dialog.hide();
  }
}
